export const SET_CONFIG = "SET_CONFIG";
export const SET_SINGLE_CONFIG = "SET_SINGLE_CONFIG";
